<template>
  <div style="text-align:right">
    <span v-if="value!=0">
      <!--  {{ value ? Intl.NumberFormat('ja-JP', { maximumSignificantDigits: 2,}).format(value) : 0 }} -->
      {{ Number(Number(value).toFixed(decimalLength||decimalPlace[field]||decimalPlace.all)).toLocaleString('ja-JP', { minimumFractionDigits:(decimalLength||decimalPlace[field]||decimalPlace.all) }) }}
    </span>
    <span v-else style="color:#5C5C5C">0</span>
  </div>
</template>
<script>
export default {
  props: ['field','value','decimalLength','decimalPlace'],
  mounted(){
    //console.log("dp",this.decimalPlace.all)
    if(this.decimalLength)
      this.$set(this.decimalPlace, this.field, this.decimalLength)
  }
}
</script>
<style>
.-td-color-comp {
  width: 50px;
  height: 20px;
  font-size: 12px;
  font-weight: bold;
  text-align: center;
  line-height: 20px;
}
</style>
